import { useMutation, useQuery } from "@tanstack/react-query";
import { Modal, message } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import AntTable from "../../../components/AntTable/AntTable";
import HeaderTableSuperAdmin from "../../../components/admin/common/HeaderTableSuperAdmin";
import PopAddNewClient from "../../../components/clients/PopAddNewClient";
import AddTeamMember from "../../../components/teamMember/creatTeamMember/AddTeamMember";
import useBreadcrumb from "../../../hooks/useBreadcrumb";
import {
  adminDeleteBulkTeamMembers,
  getTeamMembersAdmin,
} from "../../../network/admin";
import queryClient from "../../../services/react-query/queryClient";
import { teamMember } from "../../../types/calendar";

type Props = {};

const StaffManagement = (props: Props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState({
    title: "",
    para: "",
    status: "",
    color: "",
  });
  const [selectedTeamMember, setSelectedTeamMember] =
    useState<teamMember | null>(null);
  const [page, setPage] = useState<number>(1);
  const [isFilter, setIsFilter] = useState({});
  const [searchHeader, setSearchHeader] = useState();

  const [addingClientModal, setAddingClientModal] = useState(false);
  const { data, isLoading } = useQuery(
    ["AdminTeamMembers", page, isFilter, searchHeader],
    () => getTeamMembersAdmin({ page, ...isFilter, search: searchHeader })
  );
  const deleteStaffMembers = useMutation((ids: number[]) =>
    adminDeleteBulkTeamMembers(ids)
  );
  const showModal = () => {
    setAddingClientModal(true);
  };
  const handleCancel = () => {
    setAddingClientModal(false);
  };
  const actionItems = [
    {
      color: "#C43535",
      text: "Delete Team Members",
      title: "Confirm Deletion",
      description: "Are you sure you want to delete this Team Members?",
      status: "delete",
    },
  ];
  const columns: ColumnsType<any> = [
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Member name</div>
      ),
      dataIndex: "name",
      render: (text: any, record) => (
        <div className="text-sm font-normal text-color-primary">
          {record?.name}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Associated salon
        </div>
      ),
      dataIndex: "salon",

      render: (text: any, record) => (
        <div className="text-sm font-semibold text-color-primary" dir="ltr">
          {record?.locations?.map((e: any) => (
            <span>{e?.name}</span>
          ))}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Email address</div>
      ),
      dataIndex: "email",

      render: (text: any, record) => (
        <div className="text-sm text-color-primary font-base">
          {record?.email}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Phone Number</div>
      ),
      dataIndex: "totalSales",

      render: (text: any, record) => (
        <div className="text-sm text-color-primary font-base">
          {record?.phone}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Profession</div>
      ),
      dataIndex: "Profession",

      render: (text: any, record) => (
        <div className={`text-color-primary text-sm font-base`}>
          {record?.title}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          No. Appointments
        </div>
      ),
      dataIndex: "created_at",

      render: (text: any, record) => (
        <div className="text-sm text-color-primary font-base">
          <span className="w-full">{record?.appointments_count}</span>
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",

      render: (text: any, record) => (
        <div className="w-fit" onClick={() => setSelectedTeamMember(record)}>
          <AiOutlineEdit className="text-[#9999A7]" />
        </div>
      ),
    },
  ];
  const breadcrumb = useBreadcrumb([], 1);
  const showModalConfirm = (
    title: string,
    para: string,
    status: string,
    color: string
  ) => {
    setConfirmMessage({ title, para, status, color });
    setIsModalConfirmOpen(true);
  };
  const closeModalConfirm = () => {
    setIsModalConfirmOpen(false);
  };
  const deleteStaff = (data: number[], closeModal: () => void) => {
    console.log(data);
    deleteStaffMembers.mutate(data, {
      onSuccess: (res: any) => {
        if (res?.code === "ERR_BAD_REQUEST") {
          message.error(res?.response?.data?.message);
        } else {
          closeModal();
          message.success("Team Members Deleted Successfully");
          queryClient.invalidateQueries(["AdminTeamMembers"]);
        }
      },
    });
  };
  return (
    <>
      {breadcrumb}
      <Modal
        width="60%"
        open={addingClientModal}
        onCancel={handleCancel}
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        footer={null}
        destroyOnClose
      >
        <PopAddNewClient close={handleCancel} />
      </Modal>
      {selectedTeamMember ? (
        <AddTeamMember
          visible={!!selectedTeamMember}
          onClose={() => setSelectedTeamMember(null)}
          config={{
            isAdmin: true,
            locationId: selectedTeamMember?.locations[0]?.id,
            locationName: selectedTeamMember?.locations[0]?.name,
            isEdit: true,
            salonName: selectedTeamMember?.locations[0]?.name,
            teamMemberId: selectedTeamMember?.id,
            salonId: selectedTeamMember?.locations[0]?.salon_id!,
          }}
        />
      ) : null}
      <div className="bg-[#EEF0FF]">
        <AntTable
          tableColumns={columns}
          tableHeader={
            <div className="flex items-center justify-end">
              <HeaderTableSuperAdmin
                selectedRowKeys={selectedRowKeys}
                searchHeader={searchHeader}
                setSearchHeader={setSearchHeader}
                hasModal={false}
                setIsFilter={setIsFilter}
                filterType={{ bySalon: true, dateAdded: true }}
                modalId={0}
                actionItems={actionItems}
                confirmMessage={confirmMessage}
                requestDelete={deleteStaff}
                setConfirmMessage={setConfirmMessage}
                isModalConfirmOpen={isModalConfirmOpen}
                closeModalConfirm={closeModalConfirm}
                placeholderSearch="Search by salon, name .."
                showModalConfirm={showModalConfirm}
              />
            </div>
          }
          tableData={data?.data || []}
          isLoading={isLoading}
          expandRowByClick={false}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          selectionType={selectedRowKeys}
          setPage={setPage}
          page={page}
          total={data?.meta?.total}
        />
      </div>
    </>
  );
};

export default StaffManagement;
